import * as React from "react";
import type { SVGProps } from "react";

interface PenaltyKickMissedProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const PenaltyKickMissed = ({ cancelled = false, ...props }: PenaltyKickMissedProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M1.07 6.47h20.76v12H1.07z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M20.9 5.25c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.69 0-1.25-.56-1.25-1.25V8.12H3.62v10.42c0 .65-.5 1.18-1.12 1.24H2c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.9 6c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.13-.1-.23-.23-.23H3.1c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7.6c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="m9.88 10 2.32 2.32L14.53 10c.2-.2.5-.2.7 0l.32.32c.2.2.2.51 0 .7l-2.32 2.33 2.32 2.32c.2.2.2.51 0 .7l-.32.33a.5.5 0 0 1-.7 0l-2.33-2.32-2.32 2.32a.5.5 0 0 1-.7 0l-.33-.32a.5.5 0 0 1 0-.7l2.33-2.33-2.33-2.32a.5.5 0 0 1 0-.71l.32-.32c.2-.2.52-.2.71 0"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default PenaltyKickMissed;
